import { Link, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Box, IconButton, useTheme } from '@mui/material';
import { ArrowDownward, ArrowUpward, Edit } from '@mui/icons-material';

import { ListLayout } from '@frontend/features/common/components/ListLayout';
import { usePagination } from '@frontend/features/common/components/Table';
import { useGetMarkupRulesByAgencyId } from '@frontend/features/markup-rules/queries';
import { TABLE_HEIGHT_WITH_AGENCIES_LAYOUT } from '@frontend/features/agencies/constants';
import { ListContentLayout } from '@frontend/features/common/components/ListContentLayout';

import { routes } from '../routes';
import { useState } from 'react';


export const MarkupRulesList = () => {
  const { t } = useTranslation();
  const [search, setSearch] = useState('');
  const theme = useTheme();
  const { id: agencyId } = useParams();
  const pagination = usePagination();
  const navigate = useNavigate();

  const { data: rulesList, isLoading } = useGetMarkupRulesByAgencyId({
    agencyId: Number(agencyId)
  });

  const handleOnSearch = (value: string) => {
    setSearch(value);
  };

  return (
    <ListLayout padding={0} title="Markup rules" subtitle="Markup rules list">
      <ListContentLayout
        height={TABLE_HEIGHT_WITH_AGENCIES_LAYOUT}
        stickyHeader
        onSearchChange={handleOnSearch}
        onCreate={() =>
          agencyId && navigate(
            `${routes.dashboard.agencyView.root.replace(':id', agencyId)}/${routes.dashboard.agencyView.markupRulesView.replace(':ruleId', 'create')
            }`,
          )}
        columns={[
          {
            id: 'name',
            label: t('markupRules.name'),
            align: 'left',
          },
          {
            id: 'markup',
            label: t('markupRules.markup'),
            align: 'left',
          },
          {
            id: 'order',
            label: t('markupRules.order'),
            align: 'center',
          },
          { id: 'actions', label: '', align: 'right' },
        ]}
        isLoading={isLoading}

        data={{
          key: 'id',
          items: rulesList
            ? rulesList.items.map((elItem) => ({
              ...elItem,
              name: (
                <Link
                  to={`${routes.dashboard.agencyView.root.replace(':id', String(agencyId))}/${routes.dashboard.agencyView.markupRulesView.replace(':ruleId',elItem.id)
                  }`}
                >
                  {elItem.name}
                </Link>
              ),
              markup: `${elItem.value} ${elItem.type === 'percentage' ? '%' : t('markupRules.fee')}` ,
              order: (
                <Box display="flex" justifyContent="center" alignItems="center" gap={1}>
                  <IconButton>
                    <ArrowUpward />
                  </IconButton>
                  {elItem.order}
                  <IconButton>
                    <ArrowDownward />
                  </IconButton>
                </Box>
              ),
              actions: (
                <Box>
                  {agencyId && (
                    <IconButton
                      onClick={() =>
                        navigate(
                          `${routes.dashboard.agencyView.root.replace(':id', agencyId)}/${routes.dashboard.agencyView.markupRulesView.replace(':ruleId', elItem.id)
                          }`,
                        )
                      }
                    >
                      <Edit color="primary" />
                    </IconButton>
                  )}
                </Box>
              ),
            }))
            : [],
          totalCount: rulesList?.count || 0,
        }}
      />
    </ListLayout>
  );
};
